import { BrowserModule }         from '@angular/platform-browser';
import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';
import { UpgradeModule }         from '@angular/upgrade/static';

import { AppComponent }        from './app.component';
import { AppLiteModule }       from '../app-lite/app.module';
import { LoginModule }         from './login/login.module';
import { PasswordsModule }     from './passwords/passwords.module';
import { QuickbooksModule }    from './quickbooks/quickbooks.module';
import { RouterConfig }        from './routing/router.config';
import { RouterStates }        from './routing/router.states';
import { TwoFactorAuthModule } from './two-factor-auth/two-factor-auth.module';
import { UsersModule }         from './users/users.module';
import { XeroModule }          from './xero/xero.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    UpgradeModule,

    UIRouterUpgradeModule.forRoot({
      config: RouterConfig,
      states: RouterStates
    }),

    AppLiteModule,
    LoginModule,
    PasswordsModule,
    QuickbooksModule,
    TwoFactorAuthModule,
    UsersModule,
    XeroModule
  ]
})
export class AppModule {
  constructor( private upgrade: UpgradeModule ) { }

  ngDoBootstrap() {
    this.upgrade.bootstrap(document.body, ['app'], { strictDi: false });
  }
}
